import { defineRule } from "vee-validate";
import { required, email } from "@vee-validate/rules";
import { i18n } from "./vue-i18n";

defineRule("required", (value) => {
  if (required(value)) {
    return true;
  }

  return i18n.global.t('validationMsg.required');
});

// Define max length rule
defineRule("max", (value, [length]) => {
  if (value.length <= length) {
    return true;
  }
  return i18n.global.t('validationMsg.maxLength', { length });
});

// Define length rule
defineRule("length", (value, [length]) => {
  if (value.length == length) {
    return true;
  }
  return i18n.global.t('validationMsg.length', { length });
});

// Define custom DE_zip rule
defineRule("DE_zip", (value, [countryCode]) => {
  if (countryCode === "DE") {
    return /^\d{5}$/.test(value) || i18n.global.t('validationMsg.invalidDEZip');
  }
  return true;
});

// Define phone rule
defineRule("phone", (value) => {
  return /^\+?[\d]+$/.test(value) || i18n.global.t('validationMsg.invalidPhone');
});

// Define email rule
defineRule("email", email);

// Define not_internal_email rule
defineRule("not_internal_email", (value) => {
  return !/^.*@(telekom\.de|systems\.com)$/.test(value) || i18n.global.t('validationMsg.internalEmail');
});

// Define match rule
defineRule("match", (value, [otherValue]) => {
  return otherValue.toLowerCase() === value.toLowerCase() || i18n.global.t('validationMsg.confirmEmail');
});